import React from 'react'
import PropTypes from 'prop-types'
import { MenuItem, Popover, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
    popoverContent: {
        padding: theme.spacing.unit * 2,
        width: 300,
        maxHeight: 400,
        overflow: 'auto'
    },
    searchField: {
        marginBottom: theme.spacing.unit * 2
    },
    menuItem: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    selectedMenuItem: {
        backgroundColor: theme.palette.action.selected,
        '&:hover': {
            backgroundColor: theme.palette.action.selected
        }
    },
    noResults: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    }
})

//ToDo move it outside and use everywhere
class SelectWithSearch extends React.PureComponent {
    state = {
        anchorEl: null,
        open: false,
        search: ''
    }

    handleOpen = event => {
        this.setState({
            anchorEl: event.currentTarget,
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false,
            search: ''
        })
    }

    handleSearchChange = event => {
        this.setState({ search: event.target.value })
    }

    handleSelectOption = option => {
        const { onChange } = this.props

        if (onChange) {
            onChange({
                target: {
                    value: option.value,
                    name: this.props.name
                }
            })
        }

        this.handleClose()
    }

    getSelectedLabel = () => {
        const { options = [], value } = this.props
        const selectedOption = options.find(option => option.value === value)
        return selectedOption ? selectedOption.label : ''
    }

    getFilteredOptions = () => {
        const { options = [] } = this.props
        const { search } = this.state
        const searchLower = search.toLowerCase().trim()

        if (!searchLower) {
            return options
        }

        return options.filter(option => option.label.toLowerCase().includes(searchLower))
    }

    renderMenuItem = option => {
        const { classes, value } = this.props
        const isSelected = option.value === value

        return (
            <MenuItem
                key={option.value}
                onClick={() => this.handleSelectOption(option)}
                className={isSelected ? classes.selectedMenuItem : classes.menuItem}
            >
                {option.label}
            </MenuItem>
        )
    }

    render() {
        const { classes, label, disabled, fullWidth = true, error, helperText } = this.props
        const { open, anchorEl, search } = this.state

        const selectedLabel = this.getSelectedLabel()
        const filteredOptions = this.getFilteredOptions()

        return (
            <div>
                <TextField
                    label={label}
                    fullWidth={fullWidth}
                    value={selectedLabel}
                    onClick={this.handleOpen}
                    disabled={disabled}
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        readOnly: true,
                        style: { cursor: disabled ? 'default' : 'pointer' }
                    }}
                />

                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                >
                    <div className={classes.popoverContent}>
                        <TextField
                            placeholder="Пошук..."
                            fullWidth
                            value={search}
                            onChange={this.handleSearchChange}
                            autoFocus
                            className={classes.searchField}
                        />

                        {filteredOptions.length > 0 ? (
                            filteredOptions.map(this.renderMenuItem)
                        ) : (
                            <div className={classes.noResults}>Нічого не знайдено</div>
                        )}
                    </div>
                </Popover>
            </div>
        )
    }
}

SelectWithSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    label: PropTypes.string,
    value: PropTypes.any,
    name: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired
        })
    ),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string
}

SelectWithSearch.defaultProps = {
    options: [],
    disabled: false,
    fullWidth: true
}

export default withStyles(styles)(SelectWithSearch)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/SelectWithSearch.js